<template>
    <div class="mt-6 content">
        <div class="columns is-gapless is-mobile">
            <div class="column is-narrow"><i class="fad fa-fw fa-flag-swallowtail has-text-white mr-3 is-size-4"></i></div>
            <div class="column">
                <h3 class="has-text-white">Milestones & Reflections</h3>
                <p class="has-text-white">Milestones act as a checkpoints during your coursework. As you progress through your course you may be stopped to complete one of these checkpoints.</p>

                <div class="columns is-gapless mb-5 mt-5">
                    <div class="column is-narrow has-text-white"><i class="far fa-fw fa-info-circle mr-2"></i></div>
                    <div class="column has-text-white">
                        <div>Please note that these Milestones & Reflections, along with your Study Log, are further documentation of your coursework. We need this documentation when we review your course and it's required should your course be selected for audit. It is important that your reflections are authentic and thoughtful. Repetitive (or copy/pasted) reflections will be rejected and you will be asked to rewrite them or provide additional artifacts to document your course.</div>
                    </div>
                </div>
            </div>
        </div>


<!--        <p class="mt-6 has-text-white"><i class="fas fa-spin fa-spinner fa-fw mr-3"></i>Please wait. Loading course...</p>-->

        <div class="mt-6 pb-6">
            <ui-card class="pt-0 pl-4 pr-6">
                <div class="columns is-gapless mb-5 pt-5">
                    <div class="column is-narrow"><i class="far fa-fw fa-info-circle mr-2"></i></div>
                    <div class="column">
                        <div class="has-text-weight-bold">This course does not have any required milestones or reflections.</div>
                    </div>
                </div>
            </ui-card>

            <ui-card class="mb-6 pr-6" v-if="false">
                <div class="columns is-gapless mb-5 pt-5">
                    <div class="column is-narrow"><i class="far fa-fw fa-location-check mr-2 is-size-5"></i></div>
                    <div class="column">
                        <h4 class="has-text-weight-bold">Milestone 1: Getting Started (0-10 Hours)</h4>
                        <p>Now that you've completed these first 10 hours, please write a short paragraph summarizing your progress in the space below. Please include details about activities
                            you've completed in these hours and how your activities will benefit you as a professional and/or your students.</p>
                        <p class="has-text-weight-bold">Here are some additional questions related to your course to help you reflect on:</p>
                        <div v-if="reflectionPrompts" >
                            <p v-html="reflectionPrompts"></p>
                            <b-button size="is-small" class="mt-4" @click="getReflectionPrompt"><i class="fas fa-sync fa-fw mr-2"></i>Give me more ideas...</b-button>
                        </div>
                        <p v-else><i class="fas fa-spin fa-spinner fa-fw mr-3"></i> Evaluating your progress, goals, and objectives...</p>

                        <div class="mt-6">
                            <b-field label="Reflection">
                                <b-input type="textarea"></b-input>
                            </b-field>
                        </div>

                        <b-button type="is-success" class="mt-5"><strong>Submit Reflection</strong><i class="far fa-arrow-right-long ml-3"></i></b-button>
                    </div>
                </div>
            </ui-card>
        </div>
    </div>
</template>

<script>
    import {client as http} from "../../http_client";
    import moment from "moment";
    import UiCard from "../../components/UiCard";

    export default {
        components: {UiCard},
        props: ['enrollmentId'],
        data: function() {
            return {
                reflectionPrompts: null
            };
        },
        computed: {

        },
        methods: {
            getReflectionPrompt: function() {
                this.reflectionPrompts = null;
                http.post('/app/enrollments/' + this.enrollmentId + '/reflections/prompt', {}, {force: true}).then((response) => {
                    this.reflectionPrompts = response.data.prompt;
                });
            }
        },
        mounted() {
            // this.getReflectionPrompt();
        }
    };
</script>

<style scoped>

</style>
